import { render, staticRenderFns } from "./PopupShell.vue?vue&type=template&id=72a3ea99&scoped=true"
import script from "./PopupShell.vue?vue&type=script&lang=ts"
export * from "./PopupShell.vue?vue&type=script&lang=ts"
import style0 from "./PopupShell.vue?vue&type=style&index=0&id=72a3ea99&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a3ea99",
  null
  
)

export default component.exports